export default {
  namespaced: true,
  state: {
    list: [],
    pendingItem: {},
  },
  getters: {
    list: state => state.list,
    pendingItem: state => state.pendingItem,
  },
  mutations: {
    listMutate(state, data) {
      state.list = data;
    },
    pendingItemMutate(state, data) {
      state.pendingItem = data;
    },
  },
  actions: {
    setList(context, data) {
      context.commit('listMutate', data);
    },
    setPendingItem(context, data) {
      context.commit('pendingItemMutate', data);
    },
  },
};
